<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ubicación de la lista de partida: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.list_location"
                    :my_bag="my_bag"
                    outlined></RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-select
                v-model="stage.entity_type_id"
                :items="available_types"
                label="Tipo de registro a crear"
                item-text="name" 
                item-value="uuid"
                outlined
                hide-details="auto"
                @change="reset_payload"
                >
                </v-select>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    v-model="stage.save_list_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    @change="computeStage"
                ></v-text-field>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col v-if="stage.entity_type_id && my_element_schema" >
                <RecursivePayloadOfAdressesOnSchemaEditor 
                    :key="stage.entity_type_id+'_noseque'"
                    :schema="current_type.schema" 
                    :key_to_show="current_type.name"
                    :my_bag="bag_with_element"
                    v-model="stage.payload_of_addresses" />
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { CreateInstancesFromList } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RecursivePayloadOfAdressesOnSchemaEditor from '@/modules/document/infra/RecursivePayloadOfAdressesOnSchemaEditor.vue';
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
// import { get_tree_from_schema } from '@/modules/entities/domain/GetTreeFromSchema';
export default {
    name:'CreateInstancesFromListDetailComponent',
    components: {
        RouteInBagSelectorComponent,
        RecursivePayloadOfAdressesOnSchemaEditor
    },
    props:{
        stage: {
            type: CreateInstancesFromList,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag:{
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data(){
        return {
            cssLink: null,
            selected_schema: null
        }
    },
    mounted(){
        console.log(this.stage);
        // this.cssLink = document.createElement('link');
        // this.cssLink.rel = 'stylesheet';
        // this.cssLink.href = 'https://unpkg.com/json-schema-editor-vue/lib/json-schema-editor-vue.css';
        // document.head.appendChild(this.cssLink);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        
        computeStage(){
            this.$emit('compute-stage');
        },
        reset_payload(){
            console.log('reset');
            this.stage.payload_of_addresses = {};
        }
        
    },
    computed:{
        current_type(){
            if (!this.stage.entity_type_id){
                return {'name':'', 'schema':{}};
            }
            let current_type = this.available_types.find(e => e.uuid === this.stage.entity_type_id);
            return current_type;
        },
        my_element_schema(){
            if (this.stage.list_location){
                let keys = this.stage.list_location.split('.');
                let value = this.my_bag;
                for (let key of keys){
                    value = value[key];
                }
                if (value && Array.isArray(value) && value.length > 0){
                    return value[0];
                }
            }
            return null;
        },
        bag_with_element(){
            let current_bag = this.my_bag;
            this.my_bag['element'] = this.my_element_schema;
            return current_bag;
        }
        // get_context_from_output_type(){
        //     if (this.stage.entity_type_id){
        //         let e_type = this.available_types.find(e => e.uuid === this.stage.entity_type_id);
        //         return get_tree_from_schema(e_type.schema);
        //     }
        //     else{
        //         return {};
        //     }
        // }
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>